<template>
  <div id="accordion">
    <div v-for="(mod, index) in store.selectedCard.enjoy_benefits" :key="index" class="card">
      <button :class="`d-flex align-items-center w-100 ${index !== 0 ? 'collapsed' : ''}`" data-toggle="collapse" :data-target="`#collapse-${index+1}`" aria-expanded="true" :aria-controls="`collapse-${index+1}`">
        <div class="img-wrap mr-1">
          <img :src="mod.img_src" alt="">
        </div>
        <h4 class="subheading-2 ml-0-5 mb-0 pr-1" v-html="mod.heading" :id="`heading-${index+1}`"></h4>
        <img :src="`${store.baseUrl}/images/icon_caret-down.png`" class="arrow" alt="">
      </button>

      <div :id="`collapse-${index+1}`" :class="`collapse ${index === 0 ? 'show' : ''}`" :aria-labelledby="`heading-${index+1}`" data-parent="#accordion">
        <div class="wrap">
          <p v-html="mod.body" class="mt-1"></p>
          <a :href="mod.cta_href" class="link-arrow mt-1 custom_click_track" :custom_click_track_value="trackingAttr(store.selectedCard.tracking_version, 'BENEFITS', mod.tracking_id)" target="_blank">{{ mod.cta_copy }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUpdated } from 'vue';
import { useStore } from '../store';
import { shuffleArray, trackingAttr } from '../utilities';

const store = useStore();
const MODULES_AMOUNT = 3;

function setModulesDisplay() {
  const modules = store.selectedCard.enjoy_benefits;
  shuffleArray(modules);
  if (modules.length > MODULES_AMOUNT) {
    const spliceStart = MODULES_AMOUNT;
    const amountToSplice = modules.length - MODULES_AMOUNT;
    modules.splice(spliceStart, amountToSplice);
  }
}

onUpdated(() => {
  setModulesDisplay();
});

onMounted(() => {
  setModulesDisplay();
});
</script>
